 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		59: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~pages-account~pages-admin-redirects~pages-auth-PageContainer~pages-auth-SSO-LinkAccountsPage~524f8b8e","1":"vendors~99designs-apps-spa-common-CurationUploader-CurationUploaderAdd~99designs-apps-spa-common-Cur~8a93bd31","2":"vendors~99designs-apps-spa-common-CurationUploader-CurationUploaderAdd~99designs-apps-spa-common-Cur~d780d71c","3":"vendors~FacebookAdPreferences~SquarePreferences~SquarespacePreferences~activity~fileOverlay-FileOver~e4fa4edd","4":"vendors~99designs-apps-spa-common-CurationUploader-CurationUploaderAdd~99designs-apps-spa-common-Cur~f301f47d","5":"vendors~components-LogInMethodPage~pages-admin-redirects~pages-auth-PageContainer~pages-auth-SSO-New~fa0a4ca5","6":"pages-admin-redirects~pages-auth-PageContainer~pages-auth-SSO-NewUserPage~pages-auth-SSO-VerifyLinkA~d71bc7b3","7":"FacebookAdPreferences~NationBuilderPreferencesPage~PreziPreferences~SquarePreferences~SquarespacePreferences","8":"vendors~99designs-apps-spa-common-CurationUploader-CurationUploaderAdd~Uploader-DesignUploaderOverla~7297b9d1","9":"vendors~components-LogInMethodPage~components-PersonalInformationPage~components-ProfessionalBackgro~35dff39e","10":"FacebookAdPreferences~SquarePreferences~SquarespacePreferences~overview","11":"pages-account~pages-projects-ProjectsApp~pages-your-projects-YourProjectsApp~pages-your-work-YourWorkApp","12":"vendors~components-LogInMethodPage~components-PersonalInformationPage~components-ProfessionalBackgro~6457156e","13":"vendors~pages-browse-projects-BrowseProjects~pages-handover-messages~pages-projects-ProjectsApp~page~0f78862b","14":"activity~fileOverlay-FileOverlay~files","15":"vendors~components-PortfolioPage~components-ProfessionalBackgroundPage~payments","16":"FacebookAdPreferences~SquarePreferences","17":"Logos-99DesignsByVpWordmarkDe","18":"Logos-99DesignsByVpWordmarkEn","19":"Logos-99DesignsByVpWordmarkEs","20":"Logos-99DesignsByVpWordmarkFr","21":"Logos-99DesignsByVpWordmarkIt","22":"Logos-99DesignsByVpWordmarkNl","23":"Logos-99DesignsByVpWordmarkPt","24":"pages-account~pages-getting-started-GettingStartedPage","25":"pages-auth-SSO-LinkAccountsPage~pages-auth-SSO-LinkingSuccessPage","26":"vendors~99designs-apps-spa-common-CurationUploader-CurationUploaderEdit~Uploader-DesignUploaderOverlayEdit","27":"vendors~activity~pages-messages","28":"99designs-apps-spa-common-CurationUploader-CurationUploaderAdd","29":"99designs-apps-spa-common-CurationUploader-CurationUploaderEdit","30":"99designs-frontend-components-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers","31":"FacebookAdPreferences","32":"Logos-99DesignsByVpSquaremarkDe","33":"Logos-99DesignsByVpSquaremarkEn","34":"Logos-99DesignsByVpSquaremarkEs","35":"Logos-99DesignsByVpSquaremarkFr","36":"Logos-99DesignsByVpSquaremarkIt","37":"Logos-99DesignsByVpSquaremarkNl","38":"Logos-99DesignsByVpSquaremarkPt","39":"NationBuilderPreferencesPage","40":"PreziPreferences","41":"SquarePreferences","42":"SquarespacePreferences","43":"Uploader-DesignUploaderOverlayAdd","44":"Uploader-DesignUploaderOverlayEdit","45":"activity","46":"components-CurationSamplesPage-CurationSamplesPage","47":"components-LogInMethodPage","48":"components-NotificationsPage","49":"components-PersonalInformationPage","50":"components-PortfolioPage","51":"components-ProfessionalBackgroundPage","52":"components-ProfilePage","53":"components-TermsPage","54":"components-VerificationPage","55":"components-YourLevelPage","56":"design-transfer-agreement","57":"fileOverlay-FileOverlay","58":"files","60":"overview","61":"pages-account","62":"pages-admin-redirects","63":"pages-auth-PageContainer","64":"pages-auth-SSO-LinkAccountsPage","65":"pages-auth-SSO-LinkingSuccessPage","66":"pages-auth-SSO-NewUserPage","67":"pages-auth-SSO-SSOMismatchedUserPage","68":"pages-auth-SSO-VerifyLinkAccountsPage","69":"pages-auth-VerifyAddPayoutMethod","70":"pages-auth-VerifyAddPayoutRequest","71":"pages-browse-projects-BrowseProjects","72":"pages-create","73":"pages-getting-started-GettingStartedPage","74":"pages-handover-messages","75":"pages-messages","76":"pages-notifications","77":"pages-onboarder-CreatorApplicationPage","78":"pages-projects-ProjectsApp","79":"pages-projects-cancel-invites","80":"pages-projects-cancel-project","81":"pages-projects-invoices-ProjectInvoicePage","82":"pages-status","83":"pages-web-get-started-WebOnboarderPage","84":"pages-your-projects-YourProjectsApp","85":"pages-your-work-YourWorkApp","86":"payments","88":"vendors~99designs-frontend-components-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers","89":"vendors~components-PortfolioPage","90":"vendors~fileOverlay-FileOverlay"}[chunkId]||chunkId) + "." + {"0":"469abe9be7","1":"1a0b56df68","2":"e040003127","3":"78f8a02a74","4":"2eb765c354","5":"f9b0c865c8","6":"c256e93b2d","7":"8a10cf1fd4","8":"497df13484","9":"6380d49bb5","10":"42ccd50929","11":"4443536b01","12":"62658acee0","13":"fc6cc34905","14":"edaf192aab","15":"e15175812c","16":"2c8527c844","17":"4f36ab66f1","18":"f9df246573","19":"c571cec818","20":"a065510605","21":"f5e8cb9097","22":"d3254b18ab","23":"98475208dc","24":"33e6431861","25":"c49ab8eeaa","26":"11f1eb9f78","27":"c2a507fc43","28":"b4c4960c2b","29":"5ae679c029","30":"0abb076819","31":"330babd62d","32":"668ed503d6","33":"e798b1246d","34":"8e54acda2f","35":"7de51039b5","36":"c422c2a99e","37":"3bd2bc16dc","38":"a6c9c21f87","39":"c05a6955e8","40":"7cfe6797b8","41":"80638d4c72","42":"b1df483fd9","43":"396f1c228b","44":"a7f44c07f1","45":"b431ffb401","46":"5fb773b91c","47":"fc5233c9e8","48":"4b76bc6c70","49":"6cf7cdd192","50":"7da3ae47db","51":"68cb7667e6","52":"e666b08de7","53":"4fc57e597a","54":"427eed48cf","55":"7e380baf03","56":"64e934984c","57":"f385787096","58":"d993119fd1","60":"e833fcaa0f","61":"e185e50733","62":"041215d4b5","63":"91feb1709c","64":"c4bec9704f","65":"5d8199196d","66":"17efa2c931","67":"056ba9808f","68":"ba517757cd","69":"782c39f052","70":"04bae4ebc8","71":"f80bfd3c71","72":"a692eb1882","73":"d7d228dd77","74":"9d156ee127","75":"ec64fdc07f","76":"fd02398f2c","77":"3928bef08c","78":"bee672ee01","79":"7766f783a1","80":"354221e204","81":"69348bb128","82":"9ab12b1803","83":"e8420b6987","84":"e1bd220f72","85":"20999f8502","86":"b9bf9f1538","88":"991d681104","89":"61b9abc298","90":"fa2a6cd848","91":"5f5e0c6127","92":"da4abe2589","93":"05a089fa06","94":"1a467ca17d"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/en/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 373);
